import { ClientEvent } from '@udemy/event-tracking';
export class LabActionEvent extends ClientEvent {
  constructor(context) {
    super('LabActionEvent');
    this.action = void 0;
    this.hasAutomatedLabReview = void 0;
    this.inSessionTimeBetweenViewAndCtaClick = void 0;
    this.labCompletionMode = void 0;
    this.labId = void 0;
    this.labInstanceUuid = void 0;
    this.labTaskId = void 0;
    this.labTaskResourceId = void 0;
    this.labVertical = void 0;
    this.uiRegion = void 0;
    this.labId = context.labId;
    this.labVertical = context.labVertical;
    this.labInstanceUuid = context.labInstanceUuid;
    this.labTaskId = context.labTaskId;
    this.labTaskResourceId = context.labTaskResourceId;
    this.labCompletionMode = context.labCompletionMode;
    this.inSessionTimeBetweenViewAndCtaClick = context.inSessionTimeBetweenViewAndCtaClick;
    this.action = context.action;
    this.uiRegion = context.uiRegion;
    this.hasAutomatedLabReview = context.hasAutomatedLabReview;
  }
}
//# sourceMappingURL=lab-action-event.js.map